// Рантайм-полифилы ES2024 для старых браузеров / WebView.
//
// Vite собирает bundle с `target: "es2024"`, поэтому esbuild НЕ транспилирует
// и НЕ полифилит рантайм-методы вроде `Map.groupBy` / `Object.groupBy` —
// он рассчитывает, что движок их уже имеет. Эти методы появились лишь в
// Chrome 117 / Safari 17.4 / Firefox 119 (2024). На более старых браузерах
// (а также встроенных WebView корпоративных приложений) их нет → код,
// использующий `Map.groupBy(...)`, падает с `Map.groupBy is not a function`.
//
// Код-стайл проекта (rules/code-quality.md §10) поощряет `Map.groupBy` /
// `Object.groupBy`, поэтому мы не выпиливаем их из кода, а добавляем лёгкий
// полифил один раз в точке входа. Импортировать ПЕРВЫМ в main.tsx — до любого
// модуля, который может вызвать эти методы на старте.

type GroupCallback<T, K> = (item: T, index: number) => K;

// Map.groupBy — группировка в Map (ключ любого типа).
if (typeof Map.groupBy !== "function") {
	Map.groupBy = <T, K>(items: Iterable<T>, callback: GroupCallback<T, K>): Map<K, T[]> => {
		const result = new Map<K, T[]>();
		let index = 0;
		for (const item of items) {
			const key = callback(item, index++);
			const bucket = result.get(key);
			if (bucket) bucket.push(item);
			else result.set(key, [item]);
		}
		return result;
	};
}

// Object.groupBy — группировка в null-prototype объект (ключ string | symbol).
if (typeof Object.groupBy !== "function") {
	Object.groupBy = <T, K extends PropertyKey>(
		items: Iterable<T>,
		callback: GroupCallback<T, K>,
	): Partial<Record<K, T[]>> => {
		const result = Object.create(null) as Partial<Record<K, T[]>>;
		let index = 0;
		for (const item of items) {
			const key = callback(item, index++);
			const bucket = result[key];
			if (bucket) bucket.push(item);
			else result[key] = [item];
		}
		return result;
	};
}
